import { ButtonLabelLayoutTheme, styles, variants } from '../ButtonLabelLayoutStyles.css';
import { baseTheme } from './ButtonLabelLayoutBaseTheme.css';
import { multiVariantStyles } from './ButtonLabelLayoutVariants.css';
import './ButtonLabelLayoutBaseTheme.css';

/*******************
 * Component Theme
 *******************/

const ButtonLabelLayoutRedwoodTheme: ButtonLabelLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ButtonLabelLayoutRedwoodTheme };
